import { render, staticRenderFns } from "./AddDataCorrection.vue?vue&type=template&id=3e39df5e"
import script from "./AddDataCorrection.vue?vue&type=script&lang=js"
export * from "./AddDataCorrection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports